<template>
    <div class="stockProduct_single">
        <dialogPlugin :showProduct.sync='showProduct'></dialogPlugin>
        <dialogPlugin :showErrorDeleteItem.sync='showErrorDeleteItem' :listErrorOptions="listErrorOptions"></dialogPlugin>
        <Qrcode-Dialog :sluginreminder.sync="sluginreminder" :unsalableData='unsalableData' />
        <dialogPlugin :showshopOption.sync='showshopOption' @oneImport="oneImport"></dialogPlugin>
        <Qrcode-Dialog :openQueHuochuankao.sync="openQueHuochuankao"  :storeData='storeData' @upataOutOfStack="upataOutOfStack" :outOfstockReminder="outOfstockReminder" />
        <!-- 产品转移 -->
          <el-dialog
          :title="$t('other.a2618')"
          :visible.sync="transproductDia"
          width="30%"
          >
          <el-select v-model="targetStoreid" :placeholder="$t('other.a2619')" >
              <el-option v-for="item in storeOptions" :key="item.storeId" :label="item.storeName" :value="item.storeId">
              </el-option>
          </el-select>
          <span slot="footer" class="dialog-footer">
              <el-button size='small' type="primary" @click="transproductDia = false">{{$t('other.a106')}}</el-button>
              <el-button size='small' type="primary" @click="transformPorduct()">{{$t('other.a274')}}</el-button>
          </span>
          </el-dialog>
  
        <div class="vkfhikf">
            <div class="title">{{$t('other.a2624')}}（{{pageTotal}}{{$t('other.a1326')}}）</div>
             <div class="store_header">
                 <div style="width:80px;">{{$t('other.a243')}}</div>
                 <div class="pomog">
                  <span :class="{'btn':true,'active':storeId == btn.storeId}" v-for="(btn,index) in storeOptions" :key="index" @click="handle(btn,index)">{{btn.storeName}}</span>
                 </div>
              </div>
              <div class="store_header">
                 <div style="width:80px;">{{$t('other.a244')}}</div>
                 <div class="pomog">
                     <el-select size="mini" style="width:160px;margin-right:3px;" v-model="value" :placeholder="$t('other.a50')">
                          <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          </el-option>
                      </el-select>
                      <el-input size="mini" style="width:250px;" v-model="input" :placeholder="$t('other.a244')"></el-input>
                      <el-button size="mini" style="margin-left:5px" type="info"  @click="search()">{{$t('other.a245')}}</el-button>
                 </div>
              </div>
              
              <div class="weconkf">
                  
                  <div style="display:flex;align-items: center">
                      <el-checkbox class="menu" v-model="checked" @change="hanleCheckAll">{{$t('other.a2520')}}({{alltotal.length}})</el-checkbox>
                      <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
                          <el-button size="medium" type="primary">
                              {{$t('other.a2521')}} <i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                          <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item @click.native="massMoveIn()">{{$t('other.a2522')}}</el-dropdown-item>
                              <el-dropdown-item @click.native="transproductDia=true">{{$t('other.a2621')}}</el-dropdown-item>
                              <el-dropdown-item @click.native="massDeletd()">{{$t('other.a2523')}}</el-dropdown-item>
                              <!-- <el-dropdown-item @click.native="massUpdate()">批量更新重量，体积</el-dropdown-item> -->
                              <!-- <el-dropdown-item>批量更换所属SKU</el-dropdown-item> -->
                          </el-dropdown-menu>
                      </el-dropdown>
  
                      <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
                          <el-button size="medium" type="primary">
                              {{$t('other.a2625')}} <i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                          <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item @click.native="insertProduct()"> {{$t('other.a2525')}}</el-dropdown-item>
                              <el-dropdown-item @click.native="goToInsertGoods()">{{$t('other.a2526')}}</el-dropdown-item>
                              <el-dropdown-item @click.native="showshopOption=true">{{$t('other.a2626')}}</el-dropdown-item>
                          </el-dropdown-menu>
                      </el-dropdown>
                      <!-- <el-button v-if="vipLevel == 0" class="menu" size="medium" type="primary" @click="insertProduct()">导入线上产品</el-button> -->
                      <el-button class="menu" size="medium" type="primary" @click="exportStoreData()">{{$t('other.a2613')}}</el-button>
                      <el-button class="menu" size="medium" type="primary" @click="openopenQueHuotixing(1)">{{$t('other.a1834')}}(x{{outOfstockReminderAmont}})</el-button>
                      <el-button class="menu" size="medium" type="primary" @click="openopenQueHuotixing(2)">{{$t('other.a203')}}(x{{unsalable.length}})</el-button>
                  </div>
                  
              </div>
        </div>
  
        <div v-if="!overDataList.length" class="nodata">{{$t('other.a247')}}</div>
  
         <div v-else class="overseaProduct_list">
            <div :class="{'overseaProduct_item':true,'overseaProduct_item_active':activeIndex === index} " @mouseenter="activeIndex=index" @mouseleave="activeIndex=-1"  v-for="(item,index) in overDataList" :key="index" >
                <div class="lvinf">
                  <el-checkbox v-model="item.checked" @change="hanleCheckIds(item,index)"></el-checkbox>
                  <span class="createTime">{{item.createTime}}</span>
                </div>
                <div class="ovjknfk" @click="viewMore(item)">
                    <div class="pic_box">
                    <img style="width:100%" :src="item.image ? item.image : item.storeItems[0].image"  />
                      </div>
                      <div class="title_overseaProduct">{{item.groupName}}</div>
                      <div class="item_desc_parentsku">{{$t('other.a249')}}{{item.itemSku}}</div>
                      <div  class="item_desc">{{item.storeItems.length}}{{$t('other.a2615')}}</div>
                      <div  class="item_desc">{{$t('other.a2614')}}：{{item.totalNum}}</div>
                </div>
                <!-- <div class="update_overseaProduct"><span :class="{'btn':true,'btn_reverse':item.agency}">{{item.agency ? '我已分销' : $t('other.a1742')}}</span></div> -->
            </div>
        </div>
        <div class="Pager">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[15, 20, 30, 100]"
              :page-size="dataParams.offset"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
              :key="pagekey">
          </el-pagination>
      </div>
  
  
    </div>
  </template>
  
  <script>
  import utils from '../../utils/utils'
  import dialogPlugin from './component/diaload'
  import { showLoading, hideLoading } from '../../assets/js/loading.js'
  import userStoreItemsApi from '../../api/moudles/userStoreItems'
  import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
  import {mapState,mapActions,mapMutations} from 'vuex'
  export default {
  data(){
  return{
      userId:JSON.parse(localStorage.getItem('userInfo')).userId,
      storeOptions:[],
      targetIndex:[],
      listErrorOptions:[],
      showErrorDeleteItem:false,
      storeId:null,
      token:{
          token:JSON.parse(localStorage.getItem('userInfo')).token
      },
      options:[{
          label:this.$t('other.a255'),
          value:1,
      },{
          label:this.$t('other.a256'),
          value:2,
      },{
          label:this.$t('other.a257'),
          value:3,
      },],
      value:3,
      currentPage:null,
      dataParams:{
          component:true,
          cusCode:null,
          offset:100,
          page:0,
          sellerId:null,
          storeId:null,
          userId:JSON.parse(localStorage.getItem('userInfo')).userId
      },
      pageTotal:0,
      input:null,
      overDataList:[],
      checkIds:[],
      checkIdsArr:[],
      checked:false,
      activeIndex:-1,
      vipLevel:JSON.parse(localStorage.getItem('userInfo')).vipLevel,
      showProduct:false,
      showshopOption:false,
      input10:null,
      openQueHuochuankao:false,
      storeData:{},
      outOfstockReminderAmont:0,
      outOfstockReminder:[],
      remindData:[],
      sluginreminder:false,
      unsalable:[],
      unsalableData:{},
      transproductDia:false,
      targetStoreid:null,
      getDataList:[],
      pagekey:0
  
  }
  },
  
  components:{
      dialogPlugin,
      QrcodeDialog
  },
  computed:{
      ...mapState({
          mygoodslist: state => state.mygoods.mygoodslist,
        //   userId: state => state.shopaccess.userInfo.userId,
          userStormList: state => state.userStoreItems.userStormList,
          itemsCount: state => state.userStoreItems.itemsCount,
          deleTip: state => state.userStoreItems.deleTip,
          deletSuccess: state => state.userStoreItems.deletSuccess,
          getDateSuccess:state => state.userStoreItems.getDateSuccess,
          xuehuoInfo:state => state.userStoreItems.xuehuoInfo,
          xuehuoInfocount:state => state.userStoreItems.xuehuoInfocount,
          secondPassword:state=>state.shopaccess.secondPassword,
          newUserstoreItem:state=>state.userStoreItems.newUserstoreItem,
          refresh:state=>state.userStoreItems.refresh,
          slugInReminder:state => state.userStoreItems.slugInReminder,
        //   unsalable:state => state.userStoreItems.unsalable,
          
      }),
      alltotal(){
          this.targetIndex=[]
          let list=this.overDataList.filter((p,index) => {
              if(p.checked){
                  this.targetIndex.push(p.groupId)
                  return p
              }
          })
          if(list.length == this.overDataList.length){
            this.checked = true
          }
          return list ? list : []
      },
      num(){
          let num=0
          if(this.overDataList){
              num=this.overDataList.length
          }
          return num
      },
  },
  watch:{
      storeId(){
          
          this.dataParams.page=0
           this.dataParams.storeId=this.storeId
           
          if(localStorage.getItem('setPage')){
              let PageIndex = localStorage.getItem('setPageIndex')?Number(localStorage.getItem('setPageIndex')):1
              let PageSize = localStorage.getItem('setPageSize')?Number(localStorage.getItem('setPageSize')):100
              this.currentPage = PageIndex
  
              if(PageSize!=100){
                  console.log('----------PageSize')
                  this.handleSizeChange(PageSize)
                  
              }else if(PageIndex!=1){
                  console.log('----------PageIndex')
                  this.handleCurrentChange(PageIndex)
              }else {
                this.getOverseaData()
              }
          }else{
              this.getOverseaData()
          }
          
      },
      
  
    //   checked(){
    //       if(this.checked){
    //           this.overDataList.forEach(p => {
    //               p.checked=true
    //               if(this.checkIds.indexOf(p.groupId)!=-1){
    //                 // this.checkIds.slice(this.checkIds.indexOf(p.groupId),1)
    //                 // this.checkIdsArr.slice(this.checkIds.indexOf(p.groupId),1)
    //                 }else{
    //                     this.checkIds.push(p.groupId)
    //                     this.checkIdsArr.push(p)
    //                 }
    //           })
    //       }else{
    //           this.overDataList.forEach(p => {
    //               p.checked=false
    //               if(this.checkIds.indexOf(p.groupId)!=-1){
    //                 this.checkIds.slice(this.checkIds.indexOf(p.groupId),1)
    //                 this.checkIdsArr.slice(this.checkIds.indexOf(p.groupId),1)
    //                 }else{
    //                     // this.checkIds.push(p.groupId)
    //                     // this.checkIdsArr.push(p)
    //                 }
    //           })
              
    //       }
    //   },
      input(){
          if(!this.input){
              this.dataParams.cusCode=null
              this.getOverseaData()
          }
      },
  },
  created(){
    
    if(!localStorage.getItem('setPage')){
        localStorage.setItem('setPageSize',100)
        localStorage.setItem('setPageIndex',1)
    }
      this.init()
  },
  methods:{
  
      ...mapActions('userStoreItems', [
          'getStockRemind',
      ]),
      ...mapMutations('userStoreItems', [
          'TARGET_ALL',
          'GET_DATA_STATUS_COLSE',
          'KEEP_CHOOSED_ITEM',
          'SET_REPLENISHMENT_PREIOD',
          'GET_UNSALABLE_DATA'
      ]),
      hanleCheckAll(){
        if(this.checked){
              this.overDataList.forEach(p => {
                  p.checked=true
                  if(this.checkIds.indexOf(p.groupId)!=-1){
                    }else{
                        this.checkIds.push(p.groupId)
                        this.checkIdsArr.push(p)
                    }
              })
          }else{
            console.log(111)
              this.overDataList.forEach(p => {
                  p.checked=false
                  console.log(p.groupId)
                  console.log(this.checkIds.indexOf(p.groupId))
                  if(this.checkIds.indexOf(p.groupId)!=-1){
                    this.checkIds.splice(this.checkIds.indexOf(p.groupId),1)
                    this.checkIdsArr.splice(this.checkIds.indexOf(p.groupId),1)
                    }else{
                        // this.checkIds.push(p.groupId)
                        // this.checkIdsArr.push(p)
                    }
              })
              console.log(this.checkIds)
              
          }
      },
      hanleCheckIds(item,index){
        console.log(item)
        if(this.checkIds.indexOf(this.overDataList[index].groupId)!=-1){
            this.checkIds.splice(this.checkIds.indexOf(this.overDataList[index].groupId),1)
            this.checkIdsArr.splice(this.checkIds.indexOf(this.overDataList[index].groupId),1)
        }else{
            this.checkIds.push(this.overDataList[index].groupId)
            this.checkIdsArr.push(this.overDataList[index])
        }
        // item.checked = !item.checked
        console.log(this.overDataList)
      },
      transformPorduct(){
          console.log(this.targetStoreid)
          userStoreItemsApi
          .copyStoreItemByStore({
              storeId:this.storeId,
              targetStoreId:this.targetStoreid,
              type:0,
              userId:this.userId
          })
          .then(res => {
          if(res.code === 200 ){
          console.log('desc',res.data)
          this.$message.success(this.$t('other.a2623'))
          this.transproductDia=false
          this.targetStoreid=null
          }else{
          this.$message.warning(res.msg)
          this.targetStoreid=null
          }
          })
      },
  
  
  
      opensluginreminder(){
          this.unsalableData={
              storeId:this.storeId,
              storeName:this.unsalable.length +this.$t('other.a208')+ utils.showStoreName(this.storeId),
              list:this.unsalable
          }
          this.sluginreminder=true
      },
  
  
      
  
      upataOutOfStack(data){
          let arr=this.remindData.filter(p => {
              p.dayOfShip=Number(data.dayOfShip)
              p.salesAvg01=Number(p.salesAvg.toFixed(2))
              p.needStock01=p.dayOfShip*2*p.salesAvg01-p.nowStock
              return p
          })
          let list = arr.filter(p => {
              if( p.storeItem.storeId === this.storeId && p.needStock01> 0){
                  return p
              }
          })
          console.log('list',list)
  
          list.forEach(i => {
              i.needStock01=Math.ceil(i.needStock01)
              i.salesAvg01=Math.ceil(i.salesAvg01)
          })
          this.outOfstockReminderAmont=list.length
          this.outOfstockReminder=list
  
          this.storeData={
              storeId:this.storeId,
              storeName:this.outOfstockReminder.length +this.$t('other.a208') + utils.showStoreName(this.storeId)
          }
  
          console.log('storeData',this.storeData)
  
       
          
      },
  
  
      openopenQueHuotixing(num) {
          this.$router.push({
              path:'/stockProduct/stockRemind',
              query:{
                  type:0,
                  stockType:num
              }
          })
          // this.openQueHuochuankao=true
          // this.storeData={
          //     storeId:this.storeId,
          //     storeName:this.outOfstockReminder.length +this.$t('other.a208') + utils.showStoreName(this.storeId)
          // }
  
          // console.log('storeData',this.storeData)
      },
  
      viewMore(item){
          console.log(item)
          this.$router.push({
              path:'/stockProduct/productDetail',
              query:{
                  groupId:item.groupId,
                  type:0,
                  cusCode:this.value == 1||this.value == 3 ? null : this.dataParams.cusCode
              }
          })
      },
  
      goToInsertGoods(){
          this.$router.push({path:'/createProduct',query:{
              from: JSON.stringify(this.$route.path),
              storeId:JSON.stringify(this.storeId),
              addition:JSON.stringify(false),
              components:JSON.stringify(true),
              
          }})
      },
      
      search(){
          this.dataParams.cusCode=this.input
          this.getOverseaData()
      },
      removeItem(){
          if(this.targetIndex){
              this.targetIndex.forEach((p) => {
                  this.overDataList.forEach((i,index) => {
                      if(i.groupId == p){
                          i.checked=false
                          this.overDataList.splice(index,1)
                      }
                  })
              })
          }
      },
      cancelTarget(){
          this.overDataList.forEach(p => {
              p.checked=false
          })
      },
  
      exportStoreData(){
        console.log(this.checkIdsArr)
          if(this.checkIdsArr.length!=0){
          let list=[]
          this.checkIdsArr.forEach(p => {
                      if(p.storeItems){
                          p.storeItems.forEach(i => {
                              list.push({
                                  '图片链接':i.image,
                                  '用户帐号':i.userId,
                                  '用户昵称':i.userName,
                                  '产品名称':i.itemName,
                                  '仓库编码':i.cusCode,
                                  '在仓库存':i.storeNum,
                                  '线上库存':i.stock,
                                  '仓库Id':i.storeId,
                                  '仓库母sku':p.itemSku,
                                  '仓库子sku':i.skuName,
                                  '待发数量':i.unShipped,
                                  '长（cm）':i.packageWidth,
                                  '宽（cm）':i.packageLength,
                                  '高（cm）':i.packageHeight,
                                  '重量（kg）':i.weight
  
                              })
                          })
                      }
                  })
  
                  let arr= ['图片链接','用户帐号','用户昵称','产品名称','仓库编码','在仓库存','线上库存','仓库Id','仓库母sku','仓库子sku','待发数量','长（cm）','宽（cm）','高（cm）','重量（kg）']
                  utils.exPortEXml(list,arr,'warehouseProduct')
          }else{
          let list=[]
          userStoreItemsApi
          .getStoreItem({
              component:true,
              cusCode:null,
              offset:this.pageTotal+1,
              page:0,
              sellerId:null,
              storeId:this.storeId,
              userId:this.userId
          })
          .then(res => {
              if(res.code === 200) {
                 
                  console.log('仓库产品的item',res.data)
                  res.data.groups.forEach(p => {
                      if(p.storeItems){
                          p.storeItems.forEach(i => {
                              list.push({
                                  '图片链接':i.image,
                                  '用户帐号':i.userId,
                                  '用户昵称':i.userName,
                                  '产品名称':i.itemName,
                                  '仓库编码':i.cusCode,
                                  '在仓库存':i.storeNum,
                                  '线上库存':i.stock,
                                  '仓库Id':i.storeId,
                                  '仓库母sku':p.itemSku,
                                  '仓库子sku':i.skuName,
                                  '待发数量':i.unShipped,
                                  '长（cm）':i.packageWidth,
                                  '宽（cm）':i.packageLength,
                                  '高（cm）':i.packageHeight,
                                  '重量（kg）':i.weight
  
                              })
                          })
                      }
                  })
  
                  let arr= ['图片链接','用户帐号','用户昵称','产品名称','仓库编码','在仓库存','线上库存','仓库Id','仓库母sku','仓库子sku','待发数量','长（cm）','宽（cm）','高（cm）','重量（kg）']
                  utils.exPortEXml(list,arr,'warehouseProduct')
                  
              }
          })
          }
      },
      exportxml(){
          userStoreItemsApi
          .test()
          .then(res => {
          if(res.code === 200 ){
          console.log('desc',res.data)
          }else{
          this.$message.warning(res.msg)
          }
          })
      },
      oneImport(data){
          console.log(data)
          userStoreItemsApi
          .initStoreItem({
              shopIds:[data],
              storeId:this.storeId,
              userId:this.userId
          })
          .then(res => {
          if(res.code === 200 ){
          console.log('desc',res.data)
          let text=this.$t('other.a2628')+ res.data.groupCount +this.$t('other.a2629')+ res.data.bindCount +this.$t('other.a2630')+ res.data.errorCount +this.$t('other.a2631')
          this.$confirm(text, this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a955'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
          }).then(() => {})
          }else{
          this.$message.warning(res.msg)
          }
          })
      },
  
      fknv(params){
          let token="mq9tYs4d8JRYOwDFe5wubmh1RyUR8G"
          userStoreItemsApi
          .storeUpdateStoreNumAndAddressCopy(params,token)
          .then(res => {
          if(res.code === 200 ){
          console.log('desc',res.data)
         
          }else{
          this.$message.warning(res.msg)
          }
          })
      },
  
      massUpdate(){
        this.getDataList.categoryIds=null
        this.getDataList.itemName=null
        this.getDataList.normal=true
        this.getDataList.offset=200
        this.getDataList.page=0
        this.getDataList.shopIds=JSON.parse(localStorage.getItem('userInfo')).shopIds
        this.getDataList.status='NORMAL'
        this.getDataList.userId=this.userId
  
        userStoreItemsApi
        .getOnlineGoods(this.getDataList)
        .then((res) => {
          if (res.code === 200) {
            console.log('res',res.data.items)
            console.log('desx',this.overDataList)
            let list=[]
            
            res.data.items.forEach(p => {
                if(p.variations){
                    p.variations.forEach(i => {
                        list.push(i)
                    })
                }
            })
  
            console.log('list',list)
  
            this.overDataList.forEach(p => {
                p.storeItems.forEach(k => {
                    k.obj=list.find(item => item.cusCode == k.cusCode)
                    k.weight=k.obj.weight
                })
            })
  
          this.overDataList.forEach(p => {
              p.storeItems.forEach(i => {
                  i.userId='STsurpriseing678@gmail.com'
                  this.fknv(i)
              })
          })
  
            
  
  
          }else{
            this.$message.warning(res.msg)
          }
        })
      },
      massDeletd(){
              let arr=[]
              let num =0
              this.alltotal.forEach(i => {
                  i.storeItems.forEach(p => {
                      arr.push({
                          groupId:i.groupId,
                          userId:this.userId,
                          storeId:i.storeId
                      })
  
                  })
              })
  
              
  
          console.log(arr)
          
          let desc=this.$t('other.a2587') + arr.length + this.$t('other.a2588')
          this.$confirm(desc, this.$t("other.a142"), {
              confirmButtonText: this.$t('other.a145'),
              cancelButtonText: this.$t('other.a146'),
              type: 'warning'
              }).then(() => {
                  this.listErrorOptions=[]
                  userStoreItemsApi
                  .deleteGroup(arr)
                  .then(res => {
                      if(res.code === 200){
                          this.cancelTarget()
                          console.log(res.data)
                          res.data.forEach(p => {
                              if(p.code == 0){
                                  this.$message.success(this.$t('other.a565'))
                                  this.removeItem()
                              }else{
                                  this.listErrorOptions.push({
                                      cusCode:p.cusCode,
                                      desc:p.msg,
                                      storeItem:p.storeItem,
                                  })
                                  this.showErrorDeleteItem=true
                                 
                              }
                          })
  
                          // if(!this.listErrorOptions.length){
                          //     this.$message.success(this.$t('other.a565'))
                          //     
                          // }
                      
                      }
                  })
              
              })
          },
      massMoveIn(){
          let arr=[]
          this.alltotal.forEach((p,index) => {
              p.storeItems.forEach(i => {
                  arr.push({
                      cusCode:i.cusCode,
                      component:false,
                      userId:i.userId,
                      storeId:i.storeId
                  })   
              })
          })
          let text=this.$t('other.a1059') + arr.length + this.$t('other.a2632')
          this.$confirm(text, this.$t("other.a142"), {
              confirmButtonText: this.$t('other.a145'),
              cancelButtonText: this.$t('other.a146'),
              type: 'warning'
          }).then(() => {
              let total=0
              console.log(arr)
              arr.forEach(p => {
                  userStoreItemsApi
                  .updataComponent(p)
                  .then(res => {
                      console.log(res)
                      if(res.code === 200) {
                          total +=1
                          if(total == arr.length){
                              this.$message.success(this.$t('other.a2586'))
                              this.removeItem()
                          }
                          console.log('total',total)
                      }else{
                          this.$message.warning(res.msg)
                      }
                  })
              })
          })
      },
      insertProduct(){
          console.log(this.alltotal)
          this.$router.push({
              path:'/onlineGoods',
              query:{
                  storeId:this.dataParams.storeId,
                  component:true
              }
          })
      },
      getStockRemindCopy(){
          new Promise((resolve,reject) => {
             this.getStockRemind({userId:this.userId,storeId:this.storeId}).then(res => {
                 console.log('852',res)
                  if(res.code == 200) {
                      this.remindData=res.data
                      this.unsalable=res.data.filter(k => {
                          if(k.unsalable && k.storeItem.storeId === this.storeId){
                              return k
                          }
                      })
  
                      console.log('unsalable',this.unsalable)
                      let arr=res.data.filter(p => {
                          p.salesAvg01=Number(p.salesAvg.toFixed(2))
                          p.needStock01=p.dayOfShip*2*p.salesAvg01-p.nowStock
                          return p
                      })
                      let list = arr.filter(p => {
                          if( p.storeItem.storeId === this.storeId && p.needStock01> 0){
                              return p
                          }
                      })
                      resolve(list)
                  }
              })
          }).then(res => {
              res.forEach(i => {
                  i.needStock01=Math.ceil(i.needStock01)
                  i.salesAvg01=Math.ceil(i.salesAvg01)
                  i.sevenday_estimatedSales=i.salesAvg01*7
                  i.fourteenday_estimatedSales=i.salesAvg01*14
                  i.thirty_estimatedSales=Math.floor(i.salesAvg01*30 * 100) / 100
                  i.daysAvailableSale=Math.floor(i.nowStock/i.salesAvg01 * 100) / 100
              })
              this.outOfstockReminderAmont=res.length
              this.outOfstockReminder=res
              console.log('缺货提醒11',res)
          })
      },
      init(){
          //获取缺货提醒的数据
          this.getStockRemindCopy()
          let stores=JSON.parse(localStorage.getItem('userInfo')).stores
          if(stores){
              //筛选所有启用的海外仓
              for(let i=0;i<stores.length;i++){
                  if(stores[i].storeType !== 4 && stores[i].isUsed){
                      this.storeOptions.push(stores[i])
                  }
              }
              if(!this.storeOptions.length){
                  this.$message.warning(this.$t('other.a258'))
                  return
              }else{
                  let id=utils.defaultStoreId(this.storeOptions)
                  this.storeId= id ? id : this.storeOptions[0].storeId
                 
                  console.log(this.storeOptions,id)
              }
          }else{
              this.$message.warning(this.$t('other.a259'))
          }
      },
      handle(item,index){
          this.storeId=item.storeId
          utils.setDefalultStoreId(this.storeId)
          this.getStockRemindCopy()
          console.log(this.storeId)
      },
      //获取海外仓的库存产品
      getOverseaData(){
        this.checked = false
          this.getStockRemindCopy()
          showLoading()
          userStoreItemsApi
          .getStoreItem(this.dataParams)
          .then(res => {
              if(res.code === 200){
                  console.log('海外仓库数据',res.data)
                  res.data.groups.forEach(p => {
                      p.itemSku=p.itemSku ? p.itemSku : this.$t('other.a260')
                      p.createTime=utils.renderTime(p.createTime)
                      if(this.checkIds.indexOf(p.groupId)!=-1){
                      p.checked=true
                      }else{
                      p.checked=false
                      }
                      p.totalNum=0
                      p.storeItems.forEach(i => {
                          p.totalNum+=i.storeNum
                      })
                  })
  
                  this.overDataList=res.data.groups
                  this.pageTotal=res.data.count
                 
              }else{
                  this.$message.warning(res.msg)
              }
          })
      },
  
      handleSizeChange(val) {
              console.log(`每页 ${val} 条`);
              localStorage.setItem('setPageSize',val)
              this.dataParams.offset=parseInt(`${val}`)
              if(localStorage.getItem('setPage')){
                  let PageIndex = localStorage.getItem('setPageIndex')?Number(localStorage.getItem('setPageIndex')):1
                  this.handleCurrentChange(PageIndex)
              }else{
                  this.handleCurrentChange()
              }
      },
      //显示当前第几页
      handleCurrentChange(val) {
          val = val?val:1
          console.log(val)
          let pageIndex = val?val:1
          console.log(pageIndex)
          localStorage.setItem('setPageIndex',pageIndex)
          this.currentPage=parseInt(`${pageIndex}`)
          this.dataParams.page= `${pageIndex}` == 'undefined' ? 0 : (parseInt(`${pageIndex}`) -1) * this.dataParams.offset
          this.getOverseaData()
          if(localStorage.getItem('setPage')){
              this.pagekey = Date.parse(new Date())
          }
          localStorage.removeItem('setPage')
                  
  
      },
  
  }
  }
  
  </script>
  <style lang='scss' scoped>
  
  /deep/ .el-dropdown-menu__item{
      font-size: 22px;
      line-height: 45px;
      padding: 2px 15px;
      border-bottom: 1px solid #eee;
  }
  
  
  .stockProduct_single{
      background: #eee;
      min-height: 100vh;
      position: relative;
  
  
      
  
  
      .ovjknfk{
          cursor: pointer;
      }
  
  
      .Pager{
          position: fixed;
          bottom: 0;
          left: 205px;
          right: 0;
          height: 40px;
          line-height: 40px;
          background-color: #fff;
          text-align:right;
      }
  
      .nodata{
          position: absolute;
          left: 0;
          right: 0;
          margin:  auto;
          text-align: center;
          font-size: 20px;
          margin-top: 200px;
      }
  
      .lvinf{
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          padding:3px 8px
      }
  
      .createTime{
          font-size: 10px;
      }
       
  
      .title{
          font-size: 18px;
          font-weight: 400;;
          margin-bottom: 20px;
         
      }
  
      .vkfhikf{
          background-color: #fff;
          // position: fixed;
          // right: 0;
          // left: 205px;
          // z-index: 79;
          // top: 50px;
      }
  
      .weconkf{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
  
          .menu{
              margin-right: 10px;
              margin-left: 0px;
          }
      }
  
      .store_header{
          margin: 10px 0;
          background: #fff;
          padding-bottom: 7px;
          display: flex;
  
          .pomog{
              display: flex;
              flex-wrap: wrap;
              flex: 1;
             
          }
          
  
          .btn{
              border: 1px solid #d9d9d9;
              box-sizing: border-box;
              padding: 3px 2px;
              margin-right: 3px;
              margin-bottom: 5px;
              cursor: pointer;
              line-height: 20px;
              border-radius: 3px;
          }
  
          .active{
              color: #fff;
              background: #409eff;
          }
      }
  
  
      .overseaProduct_list{
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 50px;
          // padding-top: 140px;
         
         
  
          .overseaProduct_item{
              box-sizing: border-box;
              padding: 3px;
              margin: 8px 6px;
              background-color: #fff;
              border-radius: 5px;
              border: 1px solid #fff;
  
  
          }
  
          .overseaProduct_item_active{
            border: 1px solid #F56C6C;
           
          }
  
          .update_overseaProduct{
            
            text-align: right;
            margin: 7px 0;
  
            .btn{
              background-color: rgb(42, 165, 21);
              border-radius: 3px;
              padding:4px 5px;
              color: #eee;
              font-size: 12px;
              font-weight: bold;
              cursor: pointer;
            }
  
            .btn_reverse{
               background-color: #F56C6C;
                border-radius: 3px;
                padding:4px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: bold;
                cursor: pointer;
            }
          }
          
       
  
  
          .pic_box{
              width: 173px;
              height: 173px;
              overflow: hidden;
              border-radius: 5px;
              cursor: pointer;
          }
          .title_overseaProduct{
              // width:148px;
              // height: 1.7rem;
              // -webkit-line-clamp: 2;
              // text-overflow: ellipsis;
              // overflow: hidden;
              // font-size: 12px;
              // box-sizing: border-box;
              // padding: 0 0 0 6px;
  
              font-size: 12px;
              width:148px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal !important;
              word-wrap: break-word;
              min-height: 33px;
              
          }
  
          .item_desc{
            width:148px;
            height: 14px;
            overflow:hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            padding:5px 0 5px 6px;
          }
  
          .item_desc_parentsku{
            color: #F56C6C;
            width: 148px;
            height: 14px;
            overflow:hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            padding:5px 0 5px 6px ;
            white-space: nowrap;
            
          }
      }
  
  
  
  }
  </style>